<template>
  <div id="root">
    <header>
      <Publicity v-show="!running"/>
      <el-button class="res" type="text" @click="showResult = true">
        抽奖结果
      </el-button>
      <el-dropdown class="res" @command="handleCommand">
        <span class="el-dropdown-link">配置<i class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="employee">导入名单</el-dropdown-item>
          <el-dropdown-item command="photo">导入照片</el-dropdown-item>
          <el-dropdown-item command="lottery">奖项配置</el-dropdown-item>
          <el-dropdown-item command="reset">重置</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </header>
    <div id="main" :class="{ mask: showRes }"></div>
    <div id="tags">
      <ul v-for="item in datas" :key="item.key">
        <li>
          <a
              href="javascript:void(0);"
              :style="{
              color: '#fff',
            }"
          >
            {{ item.name ? item.name : 'Test' }}
            <img v-if="item.photo" :src="item.photo" :width="50" :height="50"/>
          </a>
        </li>
      </ul>
    </div>
    <transition name="bounce">
      <div id="resbox" v-show="showRes">
        <p @click="showRes = false">{{ categoryName }}({{ awardName }})</p>
        <div class="container">
          <span
              v-for="item in resArr"
              :key="item.key"
              class="itemres"
              :style="resCardStyle"
              :data-id="item.key"
              @click="showRes = false"
              :class="{
              numberOver:
                !!photos.find((d) => d.id === item.key) ||
                !!list.find((d) => d.key === item.key),
            }"
          >
            <span class="cont" v-if="!photos.find((d) => d.id === item.key)">
              <span
                  v-if="!!list.find((d) => d.key === item.key)"
                  :style="{
                  fontSize: '40px',
                }"
              >
                {{ list.find((d) => d.key === item.key).name }}
              </span>
              <span v-else>
                {{ item.name }}
              </span>
            </span>
            <img
                v-if="photos.find((d) => d.id === item.key)"
                :src="photos.find((d) => d.id === item.key).value"
                alt="photo"
                :width="160"
                :height="160"
            />
          </span>
        </div>
      </div>
    </transition>

    <el-button
        class="audio"
        type="text"
        @click="
        () => {
          playAudio(!audioPlaying);
        }
      "
    >
      <i
          class="iconfont"
          :class="[audioPlaying ? 'iconstop' : 'iconplay1']"
      ></i>
    </el-button>

    <LotteryConfig :visible.sync="showConfig" @resetconfig="reloadTagCanvas"/>
    <Tool
        @toggle="toggle"
        @resetConfig="reloadTagCanvas"
        @getPhoto="getPhoto"
        :running="running"
        :closeRes="closeRes"
    />
    <Result :visible.sync="showResult"></Result>

    <el-dialog
        :append-to-body="true"
        :visible.sync="showImport"
        :close-on-click-modal="false"
        class="import-dialog"
        width="400px"
    >
      <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入对应的工号和姓名(可直接从excel复制)，格式(工号 姓名)。如：
1 张三
2 李四
3 王五
				"
          v-model="listStr"
      ></el-input>
      <div class="footer">
        <el-button size="mini" type="primary" @click="transformList"
        >确定
        </el-button
        >
        <el-button size="mini" @click="showImport = false">取消</el-button>
      </div>
    </el-dialog>
    <Importphoto :visible.sync="showImportPhoto" @getPhoto="getPhoto" />

    <el-dialog
        :visible.sync="showClear"
        width="300px"
        :close-on-click-modal="false"
        class="c-removeoptions"
    >
      <el-form ref="form" :model="removeInfo" label-width="80px" size="mini">
        <el-form-item label="重置选项">
          <el-radio-group v-model="removeInfo.type">
            <el-radio border :label="0">重置全部数据</el-radio>
            <el-radio border :label="1">重置抽奖配置</el-radio>
            <el-radio border :label="2">重置名单</el-radio>
            <el-radio border :label="3">重置照片</el-radio>
            <el-radio border :label="4">重置抽奖结果</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="resetConfig">确定重置</el-button>
          <el-button @click="showClear = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <a class="logo" href="#"><img alt="logo" :src="logo"></a>

    <audio
        id="audiobg"
        preload="auto"
        controls
        autoplay
        loop
        @play="playHandler"
        @pause="pauseHandler"
    >
      <source :src="audioSrc"/>
      你的浏览器不支持audio标签
    </audio>
  </div>
</template>
<script>
import LotteryConfig from '@/components/LotteryConfig';
import Publicity from '@/components/Publicity';
import Tool from '@/components/Tool';
import bgaudio from '@/assets/bg.mp3';
import beginaudio from '@/assets/begin.mp3';
import {
  clearData,
  configField,
  conversionCategoryName,
  getData,
  listField,
  newLotteryField,
  removeData,
  resultField,
} from '@/helper/index';
import {luckydrawHandler} from '@/helper/algorithm';
import Result from '@/components/Result';
import {database, DB_STORE_NAME} from '@/helper/db';
import Importphoto from "./components/Importphoto.vue";
import logo from '@/assets/ledvance-logo.png';

export default {
  name: 'App',

  components: {Importphoto, LotteryConfig, Publicity, Tool, Result},

  computed: {
    resCardStyle() {
      const style = {fontSize: '30px'};
      const {number} = this.config;
      if (number < 100) {
        style.fontSize = '100px';
      } else if (number < 1000) {
        style.fontSize = '80px';
      } else if (number < 10000) {
        style.fontSize = '60px';
      }
      return style;
    },
    config: {
      get() {
        return this.$store.state.config;
      },
    },
    result: {
      get() {
        return this.$store.state.result;
      },
      set(val) {
        this.$store.commit('setResult', val);
      },
    },
    list() {
      return this.$store.state.list;
    },
    allresult() {
      let allresult = [];
      for (const key in this.result) {
        if (this.result.hasOwnProperty(key)) {
          const element = this.result[key];
          allresult = allresult.concat(element);
        }
      }
      return allresult;
    },
    datas() {
      return this.list.map((item) => {
        const photo = this.photos.find((d) => d.id === item.key);
        return {
          ...item,
          photo: photo ? photo.value : '',
        };
      });
    },
    categoryName() {
      return conversionCategoryName(this.category);
    },
    awardName() {
      const lottery = this.storeNewLottery.find(lottery => lottery.key === this.category);
      return lottery && lottery.award || '';
    },
    storeNewLottery() {
      return this.$store.state.newLottery;
    },
    photos() {
      return this.$store.state.photos;
    },
  },
  created() {
    const data = getData(configField);
    if (data) {
      this.$store.commit('setConfig', Object.assign({}, data));
    }
    const result = getData(resultField);
    if (result) {
      this.$store.commit('setResult', result);
    }

    const newLottery = getData(newLotteryField);
    if (newLottery) {
      newLottery.forEach((item) => {
        this.$store.commit('setNewLottery', item);
      });
    }

    const list = getData(listField);
    if (list) {
      this.$store.commit('setList', list);
    }
  },

  data() {
    return {
      running: false,
      showRes: false,
      showConfig: false,
      showResult: false,
      showImport: false,
      showImportPhoto: false,
      showClear: false,
      removeInfo: { type: 0 },
      listStr: '',
      resArr: [],
      category: '',
      audioPlaying: false,
      audioSrc: bgaudio,
      logo: logo
    };
  },
  watch: {
    photos: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.reloadTagCanvas();
        });
      },
    },
  },
  mounted() {
    this.startTagCanvas();
    setTimeout(() => {
      this.getPhoto();
    }, 1000);
    window.addEventListener('resize', this.reportWindowSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reportWindowSize);
  },
  methods: {
    reportWindowSize() {
      const AppCanvas = this.$el.querySelector('#rootcanvas');
      if (AppCanvas.parentElement) {
        AppCanvas.parentElement.removeChild(AppCanvas);
      }
      this.startTagCanvas();
    },
    playHandler() {
      this.audioPlaying = true;
    },
    pauseHandler() {
      this.audioPlaying = false;
    },
    playAudio(type) {
      if (type) {
        this.$el.querySelector('#audiobg').play();
      } else {
        this.$el.querySelector('#audiobg').pause();
      }
    },
    loadAudio() {
      this.$el.querySelector('#audiobg').load();
      this.$nextTick(() => {
        this.$el.querySelector('#audiobg').play();
      });
    },
    handleCommand(command) {
      switch (command) {
        case 'employee':
          this.showImport = true
          break;
        case 'photo':
          this.showImportPhoto = true
          break;
        case 'lottery':
          this.showConfig = true
          break;
        case 'reset':
          this.showClear = true
          console.log(this.showClear)
          break;
        default:
          break;
      }
    },
    transformList() {
      const {listStr} = this;
      if (!listStr) {
        this.$message.error('没有数据');
      }
      const list = [];
      const rows = listStr.split('\n');
      if (rows && rows.length > 0) {
        rows.forEach(item => {
          const rowList = item.split(/\t|\s/);
          if (rowList.length >= 2) {
            const [first, ...rest] = rowList
            const key = first.trim();
            const name = rest.join(" ").trim();
            key &&
            list.push({
              key,
              name
            });
          }
        });
      }
      this.$store.commit('setList', list);

      this.$message({
        message: '保存成功',
        type: 'success'
      });
      this.showImport = false;
      this.$nextTick(() => {
        this.reloadTagCanvas()
      });
    },
    resetConfig() {
      const type = this.removeInfo.type;
      this.$confirm('此操作将重置所选数据，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            switch (type) {
              case 0:
                clearData();
                this.$store.commit('setClearStore');
                database.clear(DB_STORE_NAME);
                break;
              case 1:
                removeData(configField);
                removeData(newLotteryField);
                this.$store.commit('setClearConfig');
                break;
              case 2:
                removeData(listField);
                this.$store.commit('setClearList');
                break;
              case 3:
                database.clear(DB_STORE_NAME);
                this.$store.commit('setClearPhotos');
                break;
              case 4:
                removeData(resultField);
                this.$store.commit('setClearResult');
                break;
              default:
                break;
            }

            this.closeRes && this.closeRes();

            this.showClear = false;
            this.$message({
              type: 'success',
              message: '重置成功!'
            });

            this.$nextTick(() => {
              this.$emit('resetConfig');
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
    },
    getPhoto() {
      database.getAll(DB_STORE_NAME).then((res) => {
        if (res && res.length > 0) {
          this.$store.commit('setPhotos', res);
        }
      });
    },
    speed() {
      return [0.1 * Math.random() + 0.01, -(0.1 * Math.random() + 0.01)];
    },
    createCanvas() {
      const canvas = document.createElement('canvas');
      canvas.width = document.body.offsetWidth;
      canvas.height = document.body.offsetHeight;
      canvas.id = 'rootcanvas';
      this.$el.querySelector('#main').appendChild(canvas);
    },
    startTagCanvas() {
      this.createCanvas();
      const {speed} = this;
      window.TagCanvas.Start('rootcanvas', 'tags', {
        textColour: null,
        initial: speed(),
        dragControl: 1,
        textHeight: 20,
        noSelect: true,
        lock: 'xy',
      });
    },
    reloadTagCanvas() {
      window.TagCanvas.Reload('rootcanvas');
    },
    closeRes() {
      this.showRes = false;
    },
    toggle(form) {
      // 抽奖开始入口
      const {speed} = this;
      if (this.running) {
        this.audioSrc = bgaudio;
        this.loadAudio();

        window.TagCanvas.SetSpeed('rootcanvas', speed());
        this.showRes = true;
        this.running = !this.running;
        this.$nextTick(() => {
          this.reloadTagCanvas();
        });
      } else {
        this.showRes = false;
        if (!form) {
          return;
        }

        const {category, num, remain, allin: allIn} = form;
        const wons = allIn ? [] : this.allresult
        let peopleRemain = this.list.filter(item => !wons.find(w => w.key === item.key)).length;
        if (peopleRemain <= 0) {
          this.$message.success('所有员工均已中奖')
          this.running = false;
          return;
        }

        this.audioSrc = beginaudio;
        this.loadAudio();

        const resArr = luckydrawHandler(
            this.list,
            wons,
            Math.min(peopleRemain, num, remain)
        );

        this.resArr = resArr;

        this.category = category;
        if (!this.result[category]) {
          this.$set(this.result, category, []);
        }
        const oldRes = this.result[category] || [];
        this.result = Object.assign({}, this.result, {
          [category]: oldRes.concat(resArr),
        });
        window.TagCanvas.SetSpeed('rootcanvas', [5, 1]);
        this.running = !this.running;
      }
    },
  }
}
</script>
<style lang="scss">
#root {
  height: 100%;
  position: relative;
  background-image: url('assets/bg.jpg');
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #121936;

  .mask {
    -webkit-filter: blur(5px);
    filter: blur(5px);
  }

  header {
    height: 50px;
    line-height: 50px;
    position: relative;

    .el-button {
      position: absolute;
      top: 17px;
      padding: 0;
      z-index: 9999;

      &.con {
        right: 20px;
      }

      &.res {
        right: 100px;
      }
    }

    .el-dropdown {
      position: absolute;
      top: 0;
      padding: 0;
      z-index: 9999;

      &.res {
        right: 20px;
      }
    }
  }

  .audio {
    position: absolute;
    top: 5px;
    left: 30px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #fff;
    border-radius: 50%;
    padding: 0;
    text-align: center;

    .iconfont {
      position: relative;
      left: 1px;
    }
  }

  .copy-right {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #ccc;
    font-size: 12px;
  }

  .bounce-enter-active {
    animation: bounce-in 1.5s;
  }

  .bounce-leave-active {
    animation: bounce-in 0s reverse;
  }
}

#main {
  height: 100%;
}

#resbox {
  position: absolute;
  top: 45%;
  left: 50%;
  width: 80vw;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;

  p {
    color: red;
    font-size: 50px;
    line-height: 120px;
  }

  .container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .itemres {
    background: #fff;
    width: 160px;
    height: 160px;
    border-radius: 4px;
    border: 1px solid #ccc;
    line-height: 160px;
    font-weight: bold;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .cont {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &.numberOver::before {
      content: attr(data-id);
      width: 30px;
      height: 22px;
      line-height: 22px;
      background-color: #fff;
      position: absolute;
      bottom: 0;
      left: 0;
      font-size: 14px;
      // border-radius: 50%;
      z-index: 1;
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.setwat-dialog {
  .colorred {
    color: red;
    font-weight: bold;
  }
}
.import-dialog {
  .footer {
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
}
.c-removeoptions {
  .el-dialog {
    height: 290px;
  }
  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0px;
  }
  .el-radio.is-bordered {
    margin-bottom: 10px;
  }
}

.logo {
  position: absolute;
  top: 80px;
  left: 30px;
  width: 164px;
  height: 58px;
}
</style>
